import {
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_FEATURED_LIST_REQUEST,
  PRODUCT_FEATURED_LIST_SUCCESS,
  PRODUCT_FEATURED_LIST_FAIL,
} from "../Constants/ProductConstants";

const initialProductListState = {
  currentKey: null,
  productsByKey: {},
  loadingByKey: {},
  errorByKey: {},
};

export const productListReducer = (
  state = initialProductListState,
  action
) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST: {
      const { key } = action.payload;

      return {
        ...state,
        currentKey: key,
        loadingByKey: {
          ...state.loadingByKey,
          [key]: true,
        },
        errorByKey: {
          ...state.errorByKey,
          [key]: null,
        },
      };
    }

    case PRODUCT_LIST_SUCCESS: {
      const { key, data } = action.payload;

      return {
        ...state,
        currentKey: key,
        productsByKey: {
          ...state.productsByKey,
          [key]: {
            products: data.products,
            page: data.page,
            pages: data.pages,
            count: data.count,
            fetchedAt: Date.now(),
          },
        },
        loadingByKey: {
          ...state.loadingByKey,
          [key]: false,
        },
        errorByKey: {
          ...state.errorByKey,
          [key]: null,
        },
      };
    }

    case PRODUCT_LIST_FAIL: {
      const { key, error } = action.payload;

      return {
        ...state,
        currentKey: key,
        loadingByKey: {
          ...state.loadingByKey,
          [key]: false,
        },
        errorByKey: {
          ...state.errorByKey,
          [key]: error,
        },
      };
    }

    default:
      return state;
  }
};

export const productFeaturedListReducer = (
  state = { products: [], loading: false, error: null, fetchedAt: null },
  action
) => {
  switch (action.type) {
    case PRODUCT_FEATURED_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PRODUCT_FEATURED_LIST_SUCCESS:
      return {
        loading: false,
        error: null,
        products: action.payload,
        fetchedAt: Date.now(),
      };

    case PRODUCT_FEATURED_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const productDetailsReducer = (
  state = { product: {}, productCache: {} },
  action
) => {
  switch (action.type) {
    case PRODUCT_DETAILS_REQUEST:
      return { ...state, loading: true };

    case PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        product: action.payload,
        productCache: {
          ...state.productCache,
          [action.payload._id]: action.payload,
        },
      };

    case PRODUCT_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};